/**
 * Whether "Other ways to plan" still offers "I want to self-fund the entire event". It goes once the
 * client has a complete self-funding account and the self-funding steps are open to the viewer
 * (active access, or an advisor or wizard): the accounts are already in, so the link would only lead
 * back into the same steps. Without active access it stays, as the way to buy or renew.
 */
import { countCompleteSelfFundingAccounts } from '@/features/funding-sources';
import { useConsumerClient } from './use-consumer-client';
import { useSelfFundAccess } from './use-self-fund-access';

export function useIsSelfFundEntryOffered(clientId: string): boolean {
  const { client } = useConsumerClient(clientId);
  const { access, isConsumerSession } = useSelfFundAccess();
  const hasAccounts =
    countCompleteSelfFundingAccounts(client?.multipleFundingSources?.selfFunding) > 0;
  const canOpenSelfFundSteps = !isConsumerSession || access === 'active';

  return !(hasAccounts && canOpenSelfFundSteps);
}
